import { Course, CourseServiceI } from '../../../index.d'
import { Api } from '../../api'

export class CourseService implements CourseServiceI {
  async getCourse(id: number): Promise<Course> {
    if (typeof id !== 'number') throw new TypeError('id is wrong')

    const { data } = await Api.get<Course>(`/api/courses/${id}`)

    return data
  }

  async enrollCourse(id: number): Promise<void> {
    if (typeof id !== 'number') throw new TypeError('id is wrong')

    await Api.post<void>(`/api/courses/${id}/users_courses`)
  }
}
